/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ShareIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABBUlEQVR4nOWTUQrCMAyGxQdvIHgW0XcR0+SlJJ5mj847eBfB4YvigxP0BHoNpbpidXO6uqFioFBK+3/5k6ZW+5voad0E4qVCWZh9FeKxIjmeF/Kur3WrGnEqEWLEFcrmIsrrq3hyhrLxLpebOaBsTbYWcOPK1wmQTM/ixLHN0gJS7lBWhQGKZGIgbglcgANZGYdBENQLQzKgN4DSQ301QGvdUMRjQD44fz16BgCSuT0H4r0iCY1WVnbh/TAByewZwCSRGkKSMAVI6EdEbvuWaEDDjnVS+PHbd156jBzdl61UwCvxOQAkTTaN8hVH5G5ek1Pf1HcByujBoElonXgJU86g/WycAOMRJmsaoWktAAAAAElFTkSuQmCC)
 */
export const ShareIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13 16V5.41l3.3 3.3a1 1 0 1 0 1.4-1.42l-5-5a1 1 0 0 0-1.4 0l-5 5a1 1 0 0 0 1.4 1.42L11 5.4V16a1 1 0 1 0 2 0Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M4 15a1 1 0 0 1 1-1h2a1 1 0 1 0 0-2H5a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a3 3 0 0 0-3-3h-2a1 1 0 1 0 0 2h2a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4Z"
        className={colorClass}
      />
    </svg>
  );
};
